import { isEqual } from '~/helpers/common/index';

export const arePropsEqual = <T extends Record<string, unknown>>(
  prevProps: Readonly<T>,
  nextProps: Readonly<T>
): boolean => {
  return isEqual(prevProps, nextProps);
};
